export enum Deployment {
    CLOUD = 'cloud',
    DATA_CENTER = 'server'
}

export interface FilterValue {
    name: string;
    queryString: string;
    deployment?: Deployment[];
}

export const deploymentsArray: FilterValue[] = [
    {
        name: 'Cloud',
        queryString: Deployment.CLOUD
    },
    {
        name: 'Data Center',
        queryString: Deployment.DATA_CENTER
    }
];

export const productsArray: FilterValue[] = [
    {
        name: 'Jira Software',
        queryString: 'jira-software',
        deployment: [Deployment.DATA_CENTER, Deployment.CLOUD]
    },
    {
        name: 'Jira Service Management',
        queryString: 'jira-service-management',
        deployment: [Deployment.DATA_CENTER, Deployment.CLOUD]
    },
    {
        name: 'Jira Core',
        queryString: 'jira',
        deployment: [Deployment.DATA_CENTER]
    },
    {
        name: 'Confluence',
        queryString: 'confluence',
        deployment: [Deployment.DATA_CENTER, Deployment.CLOUD]
    },
    {
        name: 'Hipchat',
        queryString: 'hipchat',
        deployment: [Deployment.DATA_CENTER]
    },
    {
        name: 'Bitbucket',
        queryString: 'bitbucket',
        deployment: [Deployment.DATA_CENTER, Deployment.CLOUD]
    },
    {
        name: 'Advanced Roadmaps for Jira',
        queryString: 'advanced-roadmaps-for-jira',
        deployment: [Deployment.CLOUD]
    },
    {
        name: 'Questions for Confluence',
        queryString: 'questions-for-confluence',
        deployment: [Deployment.CLOUD, Deployment.DATA_CENTER]
    },
    {
        name: 'Bamboo',
        queryString: 'bamboo',
        deployment: [Deployment.DATA_CENTER]
    },
    {
        name: 'Fisheye',
        queryString: 'fisheye',
        deployment: [Deployment.DATA_CENTER]
    },
    {
        name: 'Crucible',
        queryString: 'crucible',
        deployment: [Deployment.DATA_CENTER]
    },
    {
        name: 'Clover',
        queryString: 'clover',
        deployment: [Deployment.DATA_CENTER]
    },
    {
        name: 'Crowd',
        queryString: 'crowd',
        deployment: [Deployment.DATA_CENTER]
    },
    {
        name: 'Atlassian Cloud',
        queryString: 'atlassian-cloud',
        deployment: [Deployment.CLOUD]
    },
    {
        name: 'Team Calendars',
        queryString: 'team-calendars',
        deployment: [Deployment.DATA_CENTER, Deployment.CLOUD]
    },
    {
        name: 'Sourcetree',
        queryString: 'sourcetree',
        deployment: [Deployment.DATA_CENTER, Deployment.CLOUD]
    },
    {
        name: 'Administering Jira applications',
        queryString: 'jira-administration',
        deployment: [Deployment.DATA_CENTER, Deployment.CLOUD]
    },
    {
        name: 'Application Links',
        queryString: 'application-links',
        deployment: [Deployment.DATA_CENTER]
    },
    {
        name: 'Evaluator Resources',
        queryString: 'evaluator-resources',
        deployment: [Deployment.CLOUD]
    },
    {
        name: 'Stride',
        queryString: 'stride',
        deployment: [Deployment.CLOUD]
    },
    {
        name: 'GDPR',
        queryString: 'gdpr',
        deployment: [Deployment.CLOUD]
    },
    {
        name: 'Ultimate Permission Manager',
        queryString: 'ultimate-permission-manager',
        deployment: [Deployment.DATA_CENTER]
    },
    {
        name: 'Automation for Jira',
        queryString: 'automation-for-jira',
        deployment: [Deployment.DATA_CENTER]
    },
    {
        name: 'Jira Product Discovery',
        queryString: 'jira-product-discovery',
        deployment: [Deployment.DATA_CENTER, Deployment.CLOUD]
    },
    {
        name: 'Fisheye and Crucible',
        queryString: 'fisheye-and-crucible',
        deployment: [Deployment.DATA_CENTER, Deployment.CLOUD]
    },
    {
        name: 'Migration',
        queryString: 'migration',
        deployment: [Deployment.DATA_CENTER, Deployment.CLOUD]
    },
    {
        name: 'Atlassian Analytics',
        queryString: 'atlassian-analytics-offering',
        deployment: [Deployment.DATA_CENTER, Deployment.CLOUD]
    },
    {
        name: 'Jira Align',
        queryString: 'jira-align',
        deployment: [Deployment.DATA_CENTER, Deployment.CLOUD]
    }
];
export const dataCenterProducts = productsArray.filter((product) =>
    product.deployment?.includes(Deployment.DATA_CENTER)
);
export const cloudProducts = productsArray.filter((product) =>
    product.deployment?.includes(Deployment.CLOUD)
);
export const dataCenterProductsIds = dataCenterProducts.map(
    (product) => product.queryString
);
export const cloudProductsIds = cloudProducts.map(
    (product) => product.queryString
);
